import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GROUPS = {
  // 1) 산학융합지구조성사업
  fusion: {
    key: 'fusion',
    label: '산학융합지구조성사업',
    icon: '📚',
    subtitle: 'Industry–Academia Convergence',
    items: [
      {
        id: 'fusionsupportprogram',
        label: '산학융합지구조성사업',
        path: '/fusionSupportProgram',
      },
    ],
  },

  // 2) 기업지원사업
  corporate: {
    key: 'corporate',
    label: '기업지원사업',
    icon: '🏢',
    subtitle: 'Corporate Support Program',
    items: [
      {
        id: 'chungnamInnovationProject',
        label: '혁신프로젝트사업',
        path: '/business/chungnamInnovationProject',
      },
      {
        id: 'ChungnamInnovationCluster',
        label: '혁신클러스터',
        path: '/business/ChungnamInnovationCluster',
      },
      {
        id: 'CarbonNeutralInfrastructure',
        label: '탄소중립실증 인프라구축사업',
        path: '/business/CarbonNeutralInfrastructure',
      },
      {
        id: 'EnergyGrowthSupport',
        label: '에너지 동반성장 상생협력지원 사업',
        path: '/business/EnergyGrowthSupport',
      },
      {
        id: 'LocalYouthJob',
        label: '지역주도형 청년일자리지원 사업',
        path: '/business/LocalYouthJob',
      },
      {
        id: 'YouthJobIncentive',
        label: '청년일자리 도약장려금지원 사업',
        path: '/business/YouthJobIncentive',
      },
      {
        id: 'SMECenterSupport',
        label: '중소기업지원센터지원 사업',
        path: '/business/SMECenterSupport',
      },
      {
        id: 'DormLeaseSupport',
        label: '산업단지 기숙사 임차지원 사업',
        path: '/business/DormLeaseSupport',
      },
    ],
  },

  // 3) 인재양성사업
  talent: {
    key: 'talent',
    label: '인재양성사업',
    icon: '🎓',
    subtitle: 'Workforce Development',
    items: [
      {
        id: 'localIndustryTalentDevelopment',
        label: '지역산업맞춤형 인력양성사업',
        path: '/business/localIndustryTalentDevelopment',
      },
      {
        id: 'koreanQuickStartProgram',
        label: '한국형 퀵스타트프로그램 사업',
        path: '/business/koreanQuickStartProgram',
      },
      {
        id: 'smeResearchTalentSupport',
        label: '중소기업 연구인력 현장맞춤형 양성지원사업',
        path: '/business/smeResearchTalentSupport',
      },
      {
        id: 'FutureWorkExperience1',
        label: '미래내일일경험(사전직무교육기관)',
        path: '/business/FutureWorkExperience1',
      },
      {
        id: 'FutureWorkExperience2',
        label: '미래내일일경험(인턴형)',
        path: '/business/FutureWorkExperience2',
      },
    ],
  },

  // 4) 창업육성사업
  startup: {
    key: 'startup',
    label: '창업육성사업',
    icon: '🚀',
    subtitle: 'Startup Incubation Program',
    items: [
      {
        id: 'YouthEmploymentSupport',
        label: '당진시 청년 취·창업 지원사업',
        path: '/business/YouthEmploymentSupport',
      },
      {
        id: 'youthVentureProgram',
        label: '당진시 청년도전지원사업',
        path: '/business/youthVentureProgram',
      },
      {
        id: 'MiddleAgedStartupCenter',
        label: '당진시 중장년기술창업센터',
        path: '/business/MiddleAgedStartupCenter',
      },
      {
        id: 'YouthGrowthProject',
        label: '당진시 청년성장 프로젝트',
        path: '/business/YouthGrowthProject',
      },
      {
        id: 'HongseongYouthGrowth',
        label: '홍성군 청년성장 프로젝트',
        path: '/business/HongseongYouthGrowth',
      },
      {
        id: 'HongseongJobAdaptation',
        label: '홍성군 직장적응 지원사업',
        path: '/business/HongseongJobAdaptation',
      },
      {
        id: 'hongseongIssueWarehouse',
        label: '홍성군 잇슈창고운영사업',
        path: '/business/hongseongIssueWarehouse',
      },
    ],
  },
};

// category → (메인그룹, 서브탭) 역매핑
const categoryMap = (() => {
  const map = {};
  Object.values(GROUPS).forEach((group) => {
    group.items.forEach((item) => {
      map[item.id] = { mainKey: group.key, subId: item.id };
    });
  });
  return map;
})();

const SubTab = ({ category }) => {
  const navigate = useNavigate();

  const [mainTab, setMainTab] = useState('corporate'); // fusion | corporate | talent | startup
  const [subTab, setSubTab] = useState('');

  useEffect(() => {
    const found = categoryMap[category];
    if (found) {
      setMainTab(found.mainKey);
      setSubTab(found.subId);
    } else {
      setMainTab('corporate');
      setSubTab('chungnamInnovationProject');
    }
  }, [category]);

  const handleMainClick = (key) => {
    const group = GROUPS[key];
    if (!group || group.items.length === 0) return;

    const defaultItem = group.items[0];
    setMainTab(key);
    setSubTab(defaultItem.id);
    navigate(defaultItem.path);
  };

  const handleSubClick = (groupKey, item) => {
    setMainTab(groupKey);
    setSubTab(item.id);
    navigate(item.path);
  };

  const currentGroup = GROUPS[mainTab] || GROUPS.corporate;
  const currentSubItem = currentGroup.items.find((item) => item.id === subTab) || currentGroup.items[0];

  return (
    <div className="subtab-wrap">
      {/* 🔹 상단 섹션 헤더 (제목 + 브레드크럼) */}
      <div className="biz-section-header">
        <h2 className="biz-section-title">사업분야</h2>
        <div className="biz-breadcrumb">
          <span className="biz-breadcrumb-home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
              <path
                d="M2.5 12L12 3l9.5 9"
                fill="none"
                stroke="#cccccc"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="biz-breadcrumb-sep">›</span>
          <span className="biz-breadcrumb-item">사업분야</span>
          <span className="biz-breadcrumb-sep">›</span>
          <span className="biz-breadcrumb-item">{currentGroup.label}</span>
          {currentSubItem && (
            <>
              <span className="biz-breadcrumb-sep">›</span>
              <span className="biz-breadcrumb-item is-current">{currentSubItem.label}</span>
            </>
          )}
        </div>
        <div className="biz-section-underline" />
      </div>

      <div className="subtab-content-box">
        {/* 상단 메인 4개 탭 */}
        <div className="subtab-background">
          {Object.values(GROUPS).map((group) => (
            <button
              key={group.key}
              type="button"
              className={`subtab-item ${mainTab === group.key ? 'active' : ''}`}
              onClick={() => handleMainClick(group.key)}
            >
              <div className="subtab-item-icon">{group.icon}</div>
              <div className="subtab-item-text">
                <div className="subtab-item-title-kr">{group.label}</div>
                <div className="subtab-item-title-en">{group.subtitle}</div>
              </div>
            </button>
          ))}
        </div>

        {/* 하단 서브탭 - 새 그리드 카드 디자인 */}
        <div className="subtab-sub-wrap">
          <div className="subtab-sub-background">
            {currentGroup.items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`subtab-sub-item ${subTab === item.id ? 'active' : ''}`}
                onClick={() => handleSubClick(currentGroup.key, item)}
              >
                <span className="subtab-sub-bullet" />
                <span className="subtab-sub-label">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubTab;
